module.exports = __webpack_public_path__ + "img/V-shaped6-cylinder.addc2b3a.png";